<template>
  <div id="app" class="app">
    <router-view></router-view>
    <v-cart></v-cart>
    <m-buy ref="buybuy"></m-buy>
    <!-- 右侧工具条 -->
    <m-tools v-if="isLogin && !$store.state.IsLittleScreen"></m-tools>
  </div>
</template>

<script>
import vCart from '@/components/cart'

export default {
  name: 'App',
  data() {
    return {
      isLogin:true
    };
  },

  mounted(){
    //console.log(this.$route.path,'==========')
    let inviteCode = this.getQueryString("inviteCode")
    if (inviteCode) {
      localStorage.setItem("inviteCode",inviteCode)
      // this.$router.push('/gfMoney')
  }
    let width = document.documentElement.getBoundingClientRect().width;
    //console.log('width',width)
    this.$store.state.IsLittleScreen  = width < 1050
  },
  components: {
    vCart
  },
  watch: {
    $route(to, from) {
      if(this.$route.name == "login"){
        this.isLogin = false
      }else{
        this.isLogin = true
      }
    },
  },
  methods:{
    getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return 0;
    }
  }


}
</script>

<style lang="less">
.scrollbar {
  margin: 0 auto;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 2px;  /*高宽分别对应横竖滚动条的尺寸*/
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 6px;
  background   : #5dbcc9;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 8px;
  background   : #FFFFFF;
}
  .text-line-1 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .text-line-2 {
    -webkit-line-clamp: 2;
  }

  .text-line-3 {
    -webkit-line-clamp: 3;
  }

  .text-line-4 {
    -webkit-line-clamp: 4;
  }

  .text-line-5 {
    -webkit-line-clamp: 5;
  }

  .text-line-2, .text-line-3, .text-line-4, .text-line-5 {
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; // 弹性伸缩盒
    -webkit-box-orient: vertical; // 设置伸缩盒子元素排列方式
  }

  body{
  background-color: #f7f7f7;
  margin:0 auto;font-size:14px;font-family:"Helvetica Neue",Arial;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
b {
	font-weight: bold;
}
i {
	font-style: italic;
}
.flex {
  display: flex;
}

.flex-direction {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.align-start {
  align-items: flex-start;
}

.align-end {
  align-items: flex-end;
}

.align-center {
  align-items: center;
}

.align-stretch {
  align-items: stretch;
}

.self-start {
  align-self: flex-start;
}

.self-center {
  align-self: flex-center;
}

.self-end {
  align-self: flex-end;
}

.self-stretch {
  align-self: stretch;
}

.align-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}



</style>
